import './utils/prepare';
import './utils/debug';
import './utils/native-polyfill';
import './utils/apm-init';
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import CoreRouter from 'core/Router';
import { processEnv } from './utils/config';
import { bbtNative } from '@bbtfe/webview-bridge';
import bbtTracking from '@bbtfe/tracking';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { lazyMonitor } from './utils/lazylib';
import { useGlobalOption, ErrorBoundary } from '@bbt/react-components';
import { register, unregister } from './sw';
import './styles/index.scss';
import { initMiniUserByToken } from './utils/userinfo';
import { sendCustomEvent } from './utils/volcengine';
import { Provider, Contexts } from './context';
import { UAParser } from '@utils';

useGlobalOption({
  px2rem: px => {
    return `${(px / 100).toFixed(2)}rem`;
  }
});

dayjs.extend(duration);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

// 这两个全局对象主要给dp使用
window.bbtNative = bbtNative;
window.bbtTracking = bbtTracking;

const Ready = () => {
  const { dispatch } = Contexts();
  useEffect(() => {
    bbtNative.ready(() => {
      dispatch({
        type: 'upgrade',
        payload: {
          userAgent: UAParser()
        }
      });
    });
  }, []);
  return null;
};

ReactDOM.render(
  <ErrorBoundary
    onError={error => {
      console.log('error', error);
      sendCustomEvent({
        name: '组件全局异常',
        categories: {
          message: error?.message,
          stack: error?.stack
        }
      });
    }}
  >
    <Provider>
      <Ready />
      <CoreRouter />
    </Provider>
  </ErrorBoundary>,
  document.getElementById('app'),
  () => {
    initMiniUserByToken();
    if (processEnv.hostEnv == 'online') {
      lazyMonitor().then(bbtMonitor => {
        bbtMonitor.init({
          projectId: 'h5_fe_shop',
          pageName: 'h5_fe_shop'
        });
        if (location.pathname != '/h5_fe_shop/html/') {
          bbtMonitor.performanceEvent();
          bbtMonitor.APIEvent();
        }
      });
    }
  }
);

if (processEnv.hostEnv != 'local') {
  // register(processEnv.buildVersion);
  unregister();
}
